import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { UserDto } from './UserDto';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';

export function createUserEntityInfo<TEntity extends UserDto>(
  options: CreateEntityInfoOptions<UserDto, TEntity>
): EntityInfo<
  AppCommonSynchronizationEnvironmentTypes,
  EntityName.User,
  TEntity
> {
  return {
    entityName: EntityName.User,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<
      AppCommonSynchronizationEnvironmentTypes,
      UserDto,
      TEntity
    >(
      {
        ...BaseEntityInfoUtils.createBaseFieldInfos<AppCommonSynchronizationEnvironmentTypes>(),
        admin: {
          name: 'admin',
          defaultValue: false
        },
        email: {
          name: 'email'
        },
        name: {
          name: 'name',
          defaultValue: ''
        }
      },
      options.additionalFieldInfos
    )
  };
}
